import { render } from "./backup-target.vue?vue&type=template&id=28532f81&scoped=true"
import script from "./backup-target.vue?vue&type=script&lang=js"
export * from "./backup-target.vue?vue&type=script&lang=js"

import "./backup-target.vue?vue&type=style&index=0&id=28532f81&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28532f81"]])

export default __exports__